export const FEATURE_FLAG_EXPERIMENT_COOKIE_NAME = 'x-flag-exp'
export const FEATURE_FLAG_INTERNAL_COOKIE_NAME = 'x-flag-internal'
export const FEATURE_FLAG_ENTITY_COOKIE_NAME = 'x-flag-entity'

export const flags = {
  FLAG_EXPEDITED_SHIPPING_DISABLED:
    'my-pga-com-jrl-expedited-shipping-disabled',
  FLAG_FEAT_GROUP_EVENT_RECURRING_PAYMENTS_ENABLED:
    'my-pga-com-feat-group-event-recurring-payments-enabled',
  FLAG_FEAT_GROUP_EVENT_REGISTRATION_REDESIGN:
    'my-pga-com-feat-group-event-registration-redesign',
  /** "Recurring" (drop-in) group events: one registration per date. */
  FLAG_FEAT_GROUP_EVENT_RECURRING_INSTANCES:
    'my-pga-com-feat-group-event-recurring-instances',
  FLAG_FEAT_GROUP_EVENT_REGISTRATION_INVITES:
    'my-pga-com-feat-group-event-registration-invites',
  FLAG_STUDENT_REVENUE_STAT: 'my-pga-com-student-revenue-statistic',
  FLAG_FEAT_BYPASS_JRL_REG: 'my-pga-com-jrl-registration-date-bypass',
  FLAG_JRL_HOUSEHOLD_DEMOGRAPHIC_SURVEY:
    'my-pga-com-jrl-household-demographic-survey',
  FLAG_FEAT_COACH_BUSINESS_INSIGHTS: 'my-pga-com-coach-business-insights',
  FLAG_FEAT_COACH_ANALYTICS: 'my-pga-com-feat-coach-analytics',
  FLAG_FEAT_COACH_BENCHMARKS: 'my-pga-com-feat-coach-benchmarks',
  FLAG_FEAT_MARKETPLACE_LISTING_BANNER:
    'my-pga-com-feat-marketplace-listing-banner',
  FLAG_FEAT_HOLIDAY_LESSON_PACK_BANNER:
    'my-pga-com-feat-holiday-lesson-pack-banner',
  /** Redesigned public private lesson booking flow (all steps). */
  FLAG_FEAT_PRIVATE_BOOKING_REDESIGN:
    'my-pga-com-feat-private-booking-redesign',
  FLAG_FEAT_STUDENT_INSIGHTS: 'my-pga-com-feat-student-insights',
  FLAG_FEAT_COACH_CAMPAIGNS: 'my-pga-com-feat-coach-campaigns',
  FLAG_FEAT_COACH_VIRTUAL_COACHING: 'my-pga-com-feat-coach-virtual-coaching',
  FLAG_FEAT_MESSAGE_PROMOTION_CONTROLS:
    'my-pga-com-feat-message-promotion-controls',
  /** Academy owner multi-coach schedule UI (scoped per academy in Flagr). */
  FLAG_ACADEMY_SCHEDULE_UI: 'my-pga-com-academy-schedule-ui',
  /**
   * Synthetic (non-Flagr) key: owned academy id that unlocked the academy
   * schedule UI. Set during evaluateFlags when the flag resolves to true.
   */
  FLAG_ACADEMY_SCHEDULE_UI_ACADEMY_ID:
    'my-pga-com-academy-schedule-ui-academy-id',
}

/** Public experiments that bucket and sticky without login. */
export const ANONYMOUS_EXPERIMENT_FLAG_KEYS = new Set()
